// src/hooks/useUserData.ts
import { useEffect, useState } from "react";
import { secureGetItem } from "../utils/encryption";

export interface UserData {
  useR_ID: string;
  userdetail: any[];
  userPermission: any[];
  token?: string;
}

export const useUserData = () => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = () => {
      try {
        const data = secureGetItem("userdata");
        if (data && data.length > 0) {
          setUserData(data[0]);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        // Fallback to regular localStorage
        try {
          const dataString = localStorage.getItem("userdata");
          if (dataString) {
            const data = JSON.parse(dataString);
            if (data && data.length > 0) {
              setUserData(data[0]);
            }
          }
        } catch (fallbackError) {
          console.error("Fallback also failed:", fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  return { userData, loading };
};